// extracted by mini-css-extract-plugin
export default {"button":"SelectionActionButton_button__EQmNv7nz","icon":"SelectionActionButton_icon__AtWssHey","text":"SelectionActionButton_text__lfrvetdl"};